import axios from 'axios';

import { processAPIWithHeaders } from '@/utils/helpers.js';

const BASE_API_URL = `${import.meta.env.VITE_API_PROTOCOL}://${import.meta.env.VITE_API_DOMAIN}`;
const BASE_API_URL_FOR_PRACTITIONERS = `${import.meta.env.VITE_API_PROTOCOL}://${import.meta.env.VITE_PRAC_API_DOMAIN}`;

export async function adressApi(usersession, body) {
    const userId = usersession?.idToken.payload.sub;
    const token = usersession?.idToken.jwtToken;
    // Errors propagate: callers advance the booking flow on success, so a swallowed failure
    // would move the patient on with no address saved.
    const resp = await axios.post(`${BASE_API_URL}/secure/user/accounts/${userId}/addresses`, body, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: token,
        },
    });
    return resp;
}

export async function userAccountsApi(usersession, body) {
    console.debug(
        '🚀 ~ file: PersonalnformationAPI.js ~ line 31 ~ userAccountsApi ~ body',
        usersession?.idToken.payload.sub,
        body
    );
    const userId = usersession?.idToken.payload.sub;
    const token = usersession?.idToken.jwtToken;
    try {
        const response = await processAPIWithHeaders(`secure/users/${userId}`, 'POST', {
            body: body,
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            },
        });
        console.debug('personalInfoAccount1: ', response);
        return response;
    } catch (error) {
        console.debug('error is ', error);
        return new Error(error.message);
    }
}

export async function getAdressAPI(usersession) {
    const userId = usersession?.idToken.payload.sub;
    const token = usersession.idToken.jwtToken;
    try {
        const res = await axios.get(
            `${BASE_API_URL}/secure/user/accounts/${userId}/addresses`,

            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
            }
        );
        console.debug(res);
        return res;
    } catch (error) {
        console.debug('error is adress ', error);
        return new Error(error.message);
    }
}
